import { defineStore } from 'pinia'
import { recordMissingTranslation } from '@/services/missingTranslationReporter'
import { useUserStore } from '@/stores/user'

const parseGroupAndKey = (rawKey) => {
    const dotIdx = rawKey.indexOf('.')
    if (dotIdx === -1) return { group: '_json', key: rawKey }
    return { group: rawKey.slice(0, dotIdx), key: rawKey.slice(dotIdx + 1) }
}

export const useMissingTranslationsStore = defineStore('missingTranslations', {
    state: () => ({
        keys: new Map(),
    }),

    getters: {
        count: (state) => state.keys.size,

        list: (state) =>
            Array.from(state.keys.values()).sort((a, b) =>
                a.fullKey.localeCompare(b.fullKey)
            ),
    },

    actions: {
        record({ key: fullKey, locale, route = null }) {
            if (!fullKey) return

            const fallbackLocale = this.i18n?.global?.fallbackLocale
            const fallbackName =
                typeof fallbackLocale === 'string'
                    ? fallbackLocale
                    : fallbackLocale?.value || 'en-US'

            if (this.i18n?.global?.te?.(fullKey, fallbackName)) return

            const { group, key } = parseGroupAndKey(fullKey)
            if (group === '_json') return
            if(group.includes('@') || key.includes('@')) return

            const existing = this.keys.get(fullKey)
            if (existing) {
                existing.locales.add(locale)
                existing.count += 1
                return
            }

            this.keys.set(fullKey, {
                fullKey,
                group,
                key,
                locales: new Set([locale]),
                count: 1,
            })

            if (useUserStore().isExternalUser) {
                recordMissingTranslation({
                    fullKey,
                    group,
                    locale,
                    route: route || this.router?.currentRoute?.value?.name || null,
                })
            }
        },

        clearForRoute() {
            this.keys = new Map()
        },
    },
})
